import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AlertService, AuthenticationService } from '../_services';

@Component({ templateUrl: 'forgotpassword.component.html' })
export class ForgotPasswordComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    linksendtext: string = "";

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService) { }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
        });

        // reset login status
        this.authenticationService.logout();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.forgotpassword(this.f.username.value,"")
            .pipe(first())
            .subscribe(
                response => {
                    if (response != null) {
                        this.loading = false;
                        localStorage.setItem('userForgotPassword', JSON.stringify(response));
                        this.linksendtext = "link to change password sent succssfully";
                        //this.router.navigate([this.returnUrl]);
                    }
                    else {
                        this.loading = false;
                        this.alertService.error("Pls Try Again");
                    }
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }
}
